module.exports = (__webpack_require__(0))(26);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/models/ItemModel.js from dll-reference girder_lib
// module id = 59
// module chunks = 0